import mapboxgl from 'mapbox-gl'
import { GEOMETRY_ICONS } from './layer_config'

export class Legend {
  constructor(map, layerManager) {
    this.map = map
    this.layerManager = layerManager
  }

  addNavigationControls() {
    this.map.addControl(new mapboxgl.NavigationControl(), 'top-right')
  }

  addFullscreenControl() {
    this.map.addControl(new mapboxgl.FullscreenControl(), 'top-right')
  }

  createLayerToggleControl() {
    const container = this.createElement('div', 'mapboxgl-ctrl mapboxgl-ctrl-group legend-container')
    const { element: header, button } = this.createHeader()
    const content = this.createElement('div', 'legend-content')
    const actions = this.createActions()
    const layerList = this.createElement('div', 'legend-layer-list')

    content.append(actions, layerList)
    container.append(header, content)

    this.layerListElement = layerList
    this.setupCollapse(button, content)

    this.map.addControl({ onAdd: () => container, onRemove: () => {} }, 'bottom-right')
  }

  createHeader() {
    const element = this.createElement('div', 'legend-header')
    const title = this.createElement('strong', 'legend-title', 'Legendă')
    const button = this.createElement('button', 'legend-collapse-btn', '−')

    element.append(title, button)
    return { element, button }
  }

  createActions() {
    const container = this.createElement('div', 'legend-actions')
    const buttons = [
      { text: 'Selectează toate', value: true },
      { text: 'Deselectează toate', value: false }
    ].map((config, i) => {
      const btn = this.createElement('button', 'legend-btn', config.text)
      btn.onclick = () => {
        this.toggleAllLayers(config.value)
        buttons.forEach((b, j) => {
          b.className = 'legend-btn'
          b.classList.toggle('legend-btn-active', i === j)
          b.classList.toggle('legend-btn-inactive', i !== j)
        })
      }
      return btn
    })

    buttons[0].classList.add('legend-btn-active')
    buttons[1].classList.add('legend-btn-inactive')
    container.append(...buttons)
    return container
  }

  setupCollapse(button, content) {
    let collapsed = false
    const toggleLegend = () => {
      collapsed = !collapsed
      Object.assign(content.style, collapsed
        ? { maxHeight: '0', opacity: '0', overflow: 'hidden' }
        : { maxHeight: '500px', opacity: '1', overflow: 'visible' }
      )
      button.innerHTML = collapsed ? '+' : '−'
    }

    button.parentElement.onclick = (e) => {
      if (e.target === button || e.target === button.parentElement) {
        toggleLegend()
      }
    }
    button.onclick = (e) => {
      e.stopPropagation()
      toggleLegend()
    }
  }

  toggleAllLayers(visible) {
    if (!this.layerListElement) return

    this.layerListElement.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = visible)
    this.layerManager.getAllLayers().forEach(layer => {
      this.layerManager.toggleLayer(layer.id, visible)
      layer.visible = visible
    })
  }

  addLayerToControlSorted(layer) {
    if (!this.layerListElement || this.layerListElement.querySelector(`#toggle-${layer.id}`)) return

    const layerDiv = this.createLayerElement(layer)
    const existing = Array.from(this.layerListElement.children)
    const insertAt = existing.findIndex(el =>
      el.querySelector('label')?.textContent.toLowerCase() > layer.name.toLowerCase()
    )

    insertAt === -1
      ? this.layerListElement.appendChild(layerDiv)
      : this.layerListElement.insertBefore(layerDiv, existing[insertAt])
  }

  createLayerElement(layer) {
    const id = `toggle-${layer.id}`
    const container = this.createElement('div', 'legend-layer-item')
    container.id = `container-${id}`

    const checkbox = this.createElement('input', 'legend-checkbox')
    checkbox.type = 'checkbox'
    checkbox.checked = true
    checkbox.id = id
    checkbox.onchange = () => {
      this.layerManager.toggleLayer(layer.id, checkbox.checked)
      layer.visible = checkbox.checked
    }

    const symbol = this.createSymbol(layer)
    const label = this.createElement('label', 'legend-label', layer.name)
    label.htmlFor = id

    container.append(checkbox, symbol, label)
    container.onclick = (e) => {
      if (e.target !== checkbox && e.target !== label) {
        checkbox.checked = !checkbox.checked
        checkbox.dispatchEvent(new Event('change'))
      }
    }

    return container
  }

  createSymbol(layer) {
    const container = this.createElement('span', 'legend-symbol')
    const type = this.getGeometryType(layer.type)
    const img = this.createElement('img', `legend-symbol-${type}`)
    img.src = `data:image/svg+xml,${encodeURIComponent(GEOMETRY_ICONS[type](layer.color))}`
    container.appendChild(img)
    return container
  }

  getGeometryType(type) {
    if (type?.includes('Point')) return 'point'
    if (type?.includes('Line')) return 'line'
    return 'polygon'
  }

  createElement(tag, className, textContent) {
    const el = document.createElement(tag)
    if (className) el.className = className
    if (textContent) el.textContent = textContent
    return el
  }
}
